// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"testimonial-module--testimonial--23B8b","position":"testimonial-module--position--1iepV"};